import {
  AdminPanelSettingsRounded,
  NoPhotographyRounded,
  EditRounded
} from '@mui/icons-material'
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
} from '@mui/material'
import { makeStyles } from "@mui/styles"
import { useTheme, styles, stylesDark, Styles } from "../../providers/theme"
import { useAuth } from '../../providers/auth'
import { useEffect, useState } from 'react';
import { socket } from '../..';

const useStylesLight = makeStyles<any, Styles>({...styles})
const useStylesDark = makeStyles<any, Styles>({...stylesDark})

export default function AccountImage() {
  const {user, currentRole} = useAuth()
  const {mode} = useTheme()
  const classesLight = useStylesLight(styles)
  const classesDark = useStylesDark(stylesDark)
  const classes = mode === 'light' ? classesLight : classesDark
  const [dialog, setDialog] = useState<boolean>(false)
  const [editIconVisible, setEditIconVisible] = useState<boolean>(false)
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>(user!.photoURL)
  const [tempProfilePictureUrl, setTempProfilePictureUrl] = useState<string>(profilePictureUrl)

  useEffect(() => {
    setProfilePictureUrl(user!.photoURL)
    setTempProfilePictureUrl(user!.photoURL)
  }, [user])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      my={2}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          width: '200px',
          height: '200px',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
      {
        !!user ?
          <Box
            className={classes.userPhotoContainer}
            sx={{
              width: "200px !important",
              height: "200px !important"
            }}
          >
          {
            <Box sx={{ width: "100%", height: "100%", display: "flex", boxSizing: "border-box", padding: 0, margin: 0 }}>
              {
                user!.photoURL ?
                  <>
                    <img
                      referrerPolicy="no-referrer"
                      className={classes.userPhoto}
                      src={profilePictureUrl}
                      alt={user!.displayName !== '' ? user!.displayName : "Unknown"}
                    />
                    <IconButton
                      className={classes.addPhoto}
                      sx={{
                        '&:hover': {
                          backgroundColor: mode === 'light' ? "rgba(246, 246, 246, 0.8)" : "rgba(37, 37, 37, 0.7)",
                          transition: "background-color .5s"
                        }
                      }}
                      onClick={() => {
                        setDialog(true)
                      }}
                      onMouseEnter={() => {
                        setEditIconVisible(true)
                      }}
                      onMouseLeave={() => {
                        setEditIconVisible(false)
                      }}
                    >
                      <EditRounded
                        className={editIconVisible ? classes.editPhotoIconVisible : classes.editPhotoIconHidden}
                        sx={{
                          color: mode === 'light' ? "#252525" : "#f6f6f6",
                        }}
                        fontSize='small'/>
                    </IconButton>
                  </>
                : 
                  <>
                    <NoPhotographyRounded sx={{ width: "100%", height: "100%", transform: "scale(0.3)" }} fontSize='large' />
                    <IconButton
                      className={classes.addPhotoOpaque}
                      sx={{
                        '&:hover': {
                          backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
                          transition: "background-color .5s"
                        }
                      }}
                      onClick={() => {
                        setDialog(true)
                      }}
                      onMouseEnter={() => {
                        setEditIconVisible(true)
                      }}
                      onMouseLeave={() => {
                        setEditIconVisible(false)
                      }}
                    >
                      <EditRounded
                        className={editIconVisible ? classes.editPhotoIconVisible : classes.editPhotoIconHidden}
                        sx={{
                          color: mode === 'light' ? "#252525" : "#f6f6f6",
                        }}
                        fontSize='small'/>
                    </IconButton>
                  </>
              }
            </Box>
          }
          </Box>
        : 'loading'
      }
      {
        currentRole !== undefined && currentRole.includes('Administrator') &&
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 100
            }}
          >
            <Avatar
              sx={{
                width: "50px",
                height: "50px",
                bgcolor: "#85d201" 
              }}
            >
              <AdminPanelSettingsRounded fontSize="large" />
            </Avatar>
          </Box>
      }
      </Box>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={dialog}
        PaperProps={{
          style: {
            backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
            borderRadius: "10px",
            boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
          }
        }}
        onClose={() => setDialog(false)}
      >
        <DialogContent>
          <TextField
            autoFocus
            label={"Profile Picture Url"}
            value={tempProfilePictureUrl}
            onChange={(event) => {
              const { target: { value } } = event
              setTempProfilePictureUrl(value)
            }}
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setTempProfilePictureUrl(profilePictureUrl)
              setDialog(false)
            }}
            color="error"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setProfilePictureUrl(tempProfilePictureUrl)
              socket.emit('set_profile_picture', user!.uid, tempProfilePictureUrl || "")
              setDialog(false)
            }}
            autoFocus
            color="secondary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
